import type { LegacyMatch, PlayerSummary } from "../api/legacyTypes";
import { entitySlug } from "../utils/slug";
import { CountryMark } from "./CountryMark";
import { EntityLink } from "./EntityLink";
import { EntityLogo } from "./EntityLogo";

function resultOutcome(match: LegacyMatch, slot: 1 | 2 | 3 | 4) {
  const scores = [match.score1, match.score2, match.score3, match.score4].map(Number).filter(Number.isFinite);
  const score = Number(match[`score${slot}`]);
  if (!Number.isFinite(score) || scores.length < 2) return "";
  const ranked = [...scores].sort((left, right) => right - left);
  const advances = match.participant3 || match.participant4 ? score >= ranked[Math.min(1, ranked.length - 1)] : score === ranked[0];
  return advances ? "quick-result-advanced" : "quick-result-eliminated";
}

export function ResultParticipants({ gameId, match, summaries = {} }: { gameId: string; match: LegacyMatch; summaries?: Record<string, PlayerSummary> }) {
  return <div className="quick-result-participants">{([1, 2, 3, 4] as const).map((slot) => {
    const name = match[`participant${slot}` as keyof LegacyMatch] as string;
    const score = match[`score${slot}` as keyof LegacyMatch] as string;
    if (!name) return null;
    const teamId = slot === 1 ? match.teamId1 : slot === 2 ? match.teamId2 : "";
    const logo = slot === 1 ? match.logo1 : slot === 2 ? match.logo2 : "";
	const country = logo.startsWith("country:") ? logo.slice("country:".length) : "";
    const summary = gameId === "trackmania" ? summaries[`${gameId}/${entitySlug(name)}`] : undefined;
    return <span className={`quick-result-chip ${resultOutcome(match, slot)}`} key={`${slot}-${name}`}>
      {(summary?.country || country) && <CountryMark country={summary?.country || country} />}
      <EntityLink gameId={gameId} kind={gameId === "trackmania" ? "player" : "team"} name={name} entityId={teamId} logoUrl={country ? "" : teamId ? `/media/organization/${teamId}` : logo} showLogo={!country} />
      {summary?.organization && <EntityLogo src={summary.organization.logo_url || `/media/organization/${summary.organization.id}`} name={summary.organization.name} />}
      <strong>{score}</strong>
    </span>;
  })}</div>;
}
